import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const processWarrantyInvocingList = (warrantyInvoicing) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/invoicing',
      'authenticated': true,
      'types': [
        ActionTypes.PROCESSING_WARRANTY_INVOICING_LIST,
        ActionTypes.PROCESSED_WARRANTY_INVOICING_LIST,
        [
          ActionTypes.PROCESSED_WARRANTY_INVOICING_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': {warrantyInvoicing},
    })
  );
};

export const updateWarrantiesInvoicing = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/invoicing',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_TWC_WARRANTY_INVOICING,
        [
          ActionTypes.UPDATED_TWC_WARRANTY_INVOICING,
          MessageActions.addMessageBoxInfo('Garantías actualizadas existosamente'),
        ],
        [
          ActionTypes.UPDATED_TWC_WARRANTY_INVOICING_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const clearWarrantyInvoicingList = () => ({
  'type': ActionTypes.CLEAR_WARRANTY_INVOICING_LIST,
});
